module.exports = "/static/assets/92c49e9013cb1c9fba9b5fe3a99b011f.png";